import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Container,
    Card,
    CardBody,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select'
import MetaTags from "react-meta-tags"
import BaseService from "services/BaseService";
import CanvasFabric from "./CanvasFabric"
import UploadImage from "./UploadImage"
import "./style.scss"

const compounds = [
    { value: 'Bedaya', label: 'Bedaya' },
    { value: 'Z-Settlement', label: 'Z-Settlement' },
    { value: 'Ammar_Elmorshidy', label: 'Vanilla' }
]
const images = [
    {
        id: 1,
        path: "http://localhost:8000/uploads/images/RHkiGVKSs6Tc6bINUoYM7UDV7ir0rVv0wgoU4X2K.jpg",
        isInteract: false,
        shapes: []
    },
    {
        id: 2,
        path: "http://localhost:8000/uploads/images/cXt0ib0oogJm6Fgc1xdwabMKD2zNC0cci9fPhbdw.jpg",
        isInteract: false,
        shapes: []


    }
]
const ImageCard = ({ img, toggleAddHandler, onClick }) => {
    return (
        <Col md={12} className="my-2 mx-0  ">
            <Row onClick={onClick}>
                <Col md={12} style={{ width: "100%", height: "70px" }}>
                    <img src={img.path} style={{ width: "100%", height: "100%" }} />
                </Col>
            </Row>
            <Row className="d-flex justify-content-center">
                <Col md={4}>
                    <p >{img.id}</p>
                    <p className="bg-danger font-size-16 " style={{ textAlign: "center" }} onClick={() => toggleAddHandler(img)}>x</p>
                </Col>
            </Row>
        </Col>
    )
}
const InteractiveModePage = () => {
    const [modeData, setModeData] = useState({
        compound: null,
        images: [],

    })
    const updateModeData = (imageData) => {
        const updatedModeData = modeData ?.images ?.map(item => {
            if (item.id === imageData.id) {
                return imageData
            } else {
                return item
            }
        })
        setModeData({ ...modeData, images: [...updatedModeData] })
    }
    const [activeCanvas, setActiveCanvas] = useState(null)
    const [libraryImages, setLibraryImages] = useState([])
    useEffect(() => {
        setLibraryImages([...images])
        // setActiveCanvas(libraryImages[0])
    }, [])
    const [imagesModal, setImagesModal] = useState(false)
    const addImagesHandler = (e) => {
        let files = e.target.files
        const filesData = Object.values(files)
         const uploadedImgs = []
        if (filesData.length) {
            Promise.all(
                filesData.map(async (file) => {
                    let res = await new BaseService().postUpload(file, {});
                    const createdFiles = { ...res.data.data, shapes: [] };
                    uploadedImgs.push(createdFiles)
                }),
            ).then(() => {

                setModeData({ ...modeData, images: [...modeData.images, ...uploadedImgs] })
            });
        }
    }

    const toggleAddHandler = (img) => {
        const updatedImages = libraryImages.map((item, index) => {
            if (item.id === img.id) {
                return item.isInteract ? {
                    ...item,
                    isInteract: false
                } : {
                        ...item,
                        isInteract: true
                    }
            } else {
                return item
            }
        })
        if (!img.isInteract && img.hasOwnProperty('isInteract')) {
            setModeData(()=>{
               return   {
                    ...modeData,
                    images: modeData ?.images.concat({
                        ...img,
                        isInteract: true
                    })
                    
                }
            })

        } else {
            const updatedImagesData = modeData.images.filter(item => item.id !== img.id)
            setModeData({ ...modeData, images: [...updatedImagesData] })

        }

        setLibraryImages([...updatedImages])

    }

    const loadData = () => {

        const data = localStorage.getItem("interactiveMode")
        const parseData = JSON.parse(data)
        if(parseData){
            setModeData(parseData)

        }

    }
    useEffect(() => {
        loadData()

    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Interactive  Mode</title>
                </MetaTags>
                <Container fluid className="bg-light">
                    <Row>
                        <Col md={6} className="my-4" >
                            <Select
                                options={compounds}
                                placeholder='Select'
                                onChange={data => setModeData({ ...modeData, compound: data })}
                                value={modeData ?.compound}
                            />
                        </Col>
                        <Col md={6} className="parent-div my-4" >
                            <Row>
                                <Col md={6}>
                                    <button type="button" className="btn btn-success px-4 w-100 btn-upload ">
                                        Upload  Images</button>
                                    <input type="file" name="upfile" accept="image/*" multiple onChange={addImagesHandler} />
                                </Col>
                                <Col md={6}>
                                    <button type="button" onClick={() => setImagesModal(true)} className="btn btn-success px-4 w-100 btn-upload ">
                                        Choose From Library</button>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <CanvasFabric updateModeData={updateModeData} activeCanvas={activeCanvas} />
                        </Col>
                        <Col md={3} className="m-4">
                            {modeData ?.images ?.map(img => {
                                return (
                                    <ImageCard img={img} key={img.id} toggleAddHandler={toggleAddHandler} onClick={() => setActiveCanvas(img)} />
                                )
                            })}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <button className="btn btn-danger w-100" type="button" onClick={() => {

                                const data = JSON.stringify(modeData)
                                localStorage.setItem("interactiveMode", data)

                            }}> Submit</button>
                        </Col>
                    </Row>
                    <UploadImage
                        modal={imagesModal}
                        setModal={setImagesModal}
                        images={libraryImages}
                        toggleAddHandler={toggleAddHandler}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}
export default InteractiveModePage